import React from "react";
import PropTypes from 'prop-types';

import _ from "lodash";
import { Row } from "antd";

import { Taxes, MaskedDiv } from "./styles";
import TaxHeader from "./components/TaxHeader/TaxHeader";
import Receipts from "./components/Receipts/Receipts";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import ToJS from "../../HOC/toJS";

function showOnlyFiveReceipts(receipts) {
  let sortedReceipts = null;
  let splicedReceipts = null;
  sortedReceipts = _.orderBy(
    receipts,
    [
      function(receipt) {
        return receipt.date;
      }
    ],
    ["desc"]
  );
  if (sortedReceipts.length <= 5) {
    return sortedReceipts;
  }
  splicedReceipts = _.take(sortedReceipts, 5);
  return splicedReceipts;
}

const TaxReceipts = ({ taxReceipts, isLoading, handleViewAnalytics }) => {
  let receipts = null;
  if (isLoading === false) {
    receipts = showOnlyFiveReceipts(taxReceipts);
  }
  return isLoading === false ? (
    <Taxes>
      <Row>
        <TaxHeader />
      </Row>
      <Row>
        <MaskedDiv />
        <Receipts taxReceipts={receipts} handleViewAnalytics={handleViewAnalytics}/>
      </Row>
    </Taxes>
  ) : (
    <Preloader />
  );
};

export default TaxReceipts;

TaxReceipts.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleViewAnalytics: PropTypes.func,
  taxReceipts: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number,
      id: PropTypes.string,
      link: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};